var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kpfuiAPP",attrs:{"id":"kpfuiApp"}},[_c('Model'),_c('QuestionContainer'),_c('div',{attrs:{"id":"loadingContainer"}},[_c('Loading',{attrs:{"loadingFlag":_vm.loadingFlag}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }